// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assets del display del monto
 * @param {*} scene
 */
export function cargaAssetsDisplayMonto(scene) {
  scene.load.image(
    "displayMonto",
    ROUTES.rutaRuletaDisplayMonto + "/displayMontoResized.png"
  );

  scene.load.image(
    "displayMontoPremio",
    ROUTES.rutaRuletaDisplayMonto + "/displayMontoPremioResized.png"
  );

  scene.load.image(
    "displayMontoAlfombra",
    ROUTES.rutaRuletaDisplayMonto + "/displayMontoAlfombraResized.png"
  );

  scene.load.image(
    "displayMontoValorGanador",
    ROUTES.rutaRuletaDisplayMonto + "/displayMontoValorGanadorResized.png"
  );
}
